export const defaultPageOptions = [10, 20, 50];
